import React, { useState, useEffect } from "react";
import api from "../services/api";
import VideoCallModal from "./VideoCallModal";

// Monté globalement côté élève : détecte un appel vidéo entrant (enseignant
// -> élève) où que l'élève se trouve dans l'appli, tant que l'onglet reste
// ouvert (pas d'infra push — voir le plan de la fonctionnalité).
export default function IncomingCallListener() {
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (pending) return; // ne pas repoller pendant qu'un appel est déjà affiché
    const poll = () => {
      api.get("appels/en-attente/").then(r => {
        if (r.data.call_id) setPending(r.data);
      }).catch(() => {});
    };
    poll();
    const id = setInterval(poll, 5000);
    // Les navigateurs ralentissent fortement setInterval sur un onglet en
    // arrière-plan — si l'élève revient sur l'onglet pendant qu'un appel
    // sonne, on ne veut pas attendre le prochain tick (potentiellement
    // très tardif) pour l'afficher.
    const onVisible = () => { if (document.visibilityState === "visible") poll(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", onVisible); };
  }, [pending]);

  if (!pending) return null;
  return <VideoCallModal mode="incoming" appel={pending} onClose={() => setPending(null)} />;
}
